import { LocationGrid } from "../components/LocationGrid";
import { PageFrame } from "../components/PageFrame";
import { Reveal } from "../components/Reveal";

export function LocationsPage() {
  return (
    <PageFrame
      className="locations-page"
      label="ΑΣΟ ΩΜΕΓΑ"
      title="Τοποθεσίες"
      intro={<p>Βρείτε το Πεδίο Βολής και τα Γραφεία Συλλόγου στους χάρτες.</p>}
    >
      <Reveal className="page-section technical-frame">
        <LocationGrid />
      </Reveal>
    </PageFrame>
  );
}
